import { styled } from '@mui/material';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #f5f5f7;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Title = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1.375rem',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '120%',
  color: theme.palette.grey[950],
}));

export const Description = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '140%',
  color: theme.palette.grey[800],
  textAlign: 'center',
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2rem',
  gap: '2rem',
  backgroundColor: '#FEFEFE',
  borderRadius: '1rem',
  border: `1px solid ${theme.palette.grey[200]}`,
  width: '100%',
  maxWidth: '34rem',
}));

export const Divider = styled('div')(({ theme }) => ({
  height: '0.0625rem',
  width: '100%',
  backgroundColor: theme.palette.grey[200],
}));

export const CornerImage = styled('img')`
  position: absolute;
  bottom: 0;
  width: calc((100vw - 34rem) / 2 * 0.75);
`;
